export default function ProgrammaEvento() {
  const programma = [
    { orario: "18:00", descrizione: "Accoglienza" },
    { orario: "19:30", descrizione: "Benvenuto e saluti istituzionali" },
    { orario: "20:00", descrizione: "Cena a buffet" },
    { orario: "21:00", descrizione: "Premiazioni" },
    { orario: "22:00", descrizione: "Concerto Rudy Valentino" },
  ];

  return (
    <section className="bg-[#FFD500] rounded-[100px] sm:rounded-[300px] mt-20 px-8 py-16 max-w-6xl mx-auto text-center text-black">
      <h2 className="text-3xl sm:text-4xl font-extrabold mb-12">PROGRAMMA</h2>
          <div className="justify-center w-full">
      <div className="justify-center">
<ul className="space-y-6 text-lg sm:text-xl mx-auto w-fit text-left">
        {programma.map((voce, i) => (
<li key={i} className="flex items-center gap-6">
            <span className="font-semibold text-white w-[60px]">{voce.orario}</span>
            <span className="text-xl">→</span>
            <span>{voce.descrizione}</span>
          </li>
        ))}
      </ul>
      </div>
      </div>
      <p className="text-sm mt-12">
        Durante l’evento verranno realizzati video e fotografie a fini comunicativi aziendali.
      </p>
    </section>
  );
}
